import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Challenge from "../components/Challenge";
import Practice from "../components/Practice";
import Process from "../components/Process";
import Specialisation from "../components/Specialisation";
import WhyUs from "../components/WhyUs";
import Pricing from "../components/Pricing";
import About from "../components/About";
import Testimonial from "../components/Testimonial";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { Toaster } from "../components/ui/toaster";

export default function Landing() {
  useEffect(() => {
    document.title = "Sang Made Diva Agastya LLC — Owner-side Property Consultancy";
  }, []);
  return (
    <div>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Challenge />
        <Practice />
        <Process />
        <Specialisation />
        <WhyUs />
        <Pricing />
        <About />
        <Testimonial />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}
